import { forwardRef, useCallback, useMemo } from 'react';
import { UserGroupEnum } from 'videoservice-openapi-react';
import { BroadcastFilterDate } from 'features/broadcast/filter-date';
import { BroadcastFilterLive } from 'features/broadcast/filter-live';
import { BroadcastFilterMappingType } from 'features/broadcast/filter-mapping-type';
import { BroadcastFilterProviders } from 'features/broadcast/filter-providers';
import { BroadcastFilterSearch } from 'features/broadcast/filter-search';
import { BroadcastFilterSports } from 'features/broadcast/filter-sports';
import { ResetFilters } from 'features/broadcast/reset-filters';
import { useModalContext } from 'shared/lib/modal';
import { useHasRole } from 'shared/lib/role';
import { Button } from 'shared/ui';
import { CardStyled } from 'shared/ui/card';
import { AddBroadcastModalContent } from '../add-broadcast-modal-content';
import { FilterStyled } from './filter.styled';

export const Filter = forwardRef<HTMLDivElement>((_, ref) => {
  const { hasRole } = useHasRole();
  const { openModal } = useModalContext();

  const canFilterMapType = useMemo(
    () => hasRole(UserGroupEnum.ADMIN, UserGroupEnum.OPERATOR),
    [hasRole],
  );

  const canAddBroadcast = useMemo(
    () => hasRole(UserGroupEnum.CUSTOMER),
    [hasRole],
  );

  const addBroadcastClickHandler = useCallback(() => {
    openModal(<AddBroadcastModalContent />);
  }, [openModal]);

  return (
    <CardStyled ref={ref}>
      <FilterStyled>
        <div className="controls">
          <BroadcastFilterDate />
          <BroadcastFilterSearch />
          <BroadcastFilterSports />
          <BroadcastFilterLive />
          {canFilterMapType && <BroadcastFilterMappingType />}
          {canAddBroadcast && (
            <div className="control-action">
              <Button onClick={addBroadcastClickHandler}>
                Добавить трансляцию
              </Button>
            </div>
          )}
        </div>
        <BroadcastFilterProviders />
        <div className="actions">
          <ResetFilters />
        </div>
      </FilterStyled>
    </CardStyled>
  );
});
